import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-792c7c1c")

_pushScopeId("data-v-792c7c1c")
const _hoisted_1 = { class: "period-picker mb-3" }
const _hoisted_2 = { class: "field is-horizontal" }
const _hoisted_3 = { class: "field mr-4 mb-0" }
const _hoisted_4 = { class: "field mr-4 mb-0" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "icon is-small" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-times" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("input", {
          class: ["input", { 'is-danger': _ctx.hasFromError }],
          placeholder: "00:00",
          ref: "fromInput",
          pattern: "^\\d\\d:\\d\\d$",
          value: _ctx.modelValue.from,
          onInput: _cache[1] || (_cache[1] = 
            $event =>
              _ctx.emit('update:modelValue', {
                ..._ctx.modelValue,
                from: $event.target.value
              })
          )
        }, null, 42, ["value"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("input", {
          class: ["input", { 'is-danger': _ctx.hasToError }],
          placeholder: "00:00",
          ref: "toInput",
          pattern: "^\\d\\d:\\d\\d$",
          value: _ctx.modelValue.to,
          onInput: _cache[2] || (_cache[2] = 
            $event =>
              _ctx.emit('update:modelValue', {
                ..._ctx.modelValue,
                to: $event.target.value
              })
          )
        }, null, 42, ["value"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("button", {
          type: "button",
          disabled: _ctx.disableDelete,
          class: "button",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emit('remove')))
        }, [
          _hoisted_6
        ], 8, ["disabled"])
      ])
    ])
  ]))
})